import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import CcRadioGroupText from '@/views/Automation/CampaignCreatorV2/components/CcRadioGroup/CcRadioGroupText.ts.vue';
import { AspectRatio } from '@/views/Automation/CampaignCreatorV2/components/Modals/CcAddImageModal/types';
import {
  CropVariations,
  ImageCreative,
  SupportedCrop,
} from '@/views/Automation/CampaignCreatorV2/helpers/facebook/AdCreative';
import { computed, onMounted, ref } from 'vue';
import { Preview } from 'vue-advanced-cropper';

// Duplicated types because vue < 3.3 doesn't support declaring Props with an imported type

interface Props extends ImageCreative {
  image_url: string;
  width?: number;
  height?: number;
  size?: number;
  cropVariations?: CropVariations;
  aspectRatio: AspectRatio;
  disabled?: boolean;
}

interface Emits {
  (e: 'onImageCrop', value: SupportedCrop | ''): void;
  (e: 'onImageEdit'): void;
  (e: 'onImageReplace'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcImagePlacementCrop.ts',
  props: {
    image_url: null,
    width: null,
    height: null,
    size: null,
    cropVariations: null,
    aspectRatio: null,
    disabled: { type: Boolean }
  },
  emits: ["onImageCrop", "onImageEdit", "onImageReplace"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'onImageCrop', value: SupportedCrop | ''): void;
  (e: 'onImageEdit'): void;
  (e: 'onImageReplace'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  image_url: string;
  width?: number;
  height?: number;
  size?: number;
  cropVariations?: CropVariations;
  aspectRatio: AspectRatio;
  disabled?: boolean;
};





const imageContainer = ref<HTMLElement | null>(null);
const isReady = ref<boolean>(false);

const croppedImage = computed(() => {
  const data = props.cropVariations?.[props.aspectRatio.value];

  if (data?.useCrop) {
    return data;
  }
  return null;
});

const selected = computed(() => {
  if (croppedImage.value) {
    return props.aspectRatio.value;
  }
  return '';
});

onMounted(() => {
  setTimeout(() => {
    isReady.value = true;
  });
});

const options: { text: string; value: SupportedCrop | '' }[] = [
  {
    text: 'Original',
    value: '',
  },
  {
    text: props.aspectRatio.option,
    value: props.aspectRatio.value,
  },
];

function onCropImageClick(value: string) {
  emits('onImageCrop', value as SupportedCrop | '');
}

function onReplaceImageClick() {
  emits('onImageReplace');
}

return { __sfc: true,emits, props, imageContainer, isReady, croppedImage, selected, options, onCropImageClick, onReplaceImageClick, CcIcon, CcRadioGroupText, Preview }
}

})